import { Money, Tire, TireInQuoteItem } from 'noddi-types';

export function getDimensionsString(tire: Tire): string {
  return `${tire.dimensionWidthMm}/${tire.dimensionProfile}R${tire.dimensionRimInch}`;
}

export function getDimensionsLoadSpeedString(tire: Tire): string {
  return `${getDimensionsString(tire)} ${tire.loadIndex.index} ${tire.speedIndex.index} `;
}

export function getQuantityOptionsEnglish(quantityMax: number) {
  return Array.from({ length: quantityMax }, (_, i) => ({
    label: `${i + 1} pcs`,
    value: i + 1
  }));
}

export function getTirePrice(tireQuoteItem: TireInQuoteItem): Money {
  return tireQuoteItem?.priceAdHoc ?? tireQuoteItem.tireInventory.salesItem.price;
}
export function getSpeedIndex(speedIndex: Tire['speedIndex']) {
  return `${speedIndex.index} (${speedIndex.speed.value} km/h)`;
}

export function getLoadIndex(tire: Tire) {
  return `${tire.loadIndex.index}`;
}

export const formatTireDimension = (value: string) => {
  // Remove all non-digit and non-R characters
  const cleanedValue = value.replace(/[^0-9rR]/g, '').toUpperCase();

  // Auto-insert "/" and convert to uppercase
  let formattedValue = cleanedValue;
  if (cleanedValue.length > 3 && cleanedValue[3] !== '/') {
    formattedValue = cleanedValue.slice(0, 3) + '/' + cleanedValue.slice(3);
  }
  if (formattedValue.length > 6 && formattedValue[6] !== 'R') {
    formattedValue = formattedValue.slice(0, 6) + 'R' + formattedValue.slice(6);
  }

  return formattedValue;
};

export const tireDimensionRegex = /^\d{3}\/\d{2}R\d{2}$/;

export const getDimensionProfilesFromTireDimension = (tireDimension: string) => {
  const dimensionWidth = getDimensionWidthFromTireDimension(tireDimension);
  const dimensionProfile = getDimensionProfileFromTireDimension(tireDimension);
  const dimensionRim = getDimensionRimFromTireDimension(tireDimension);

  return { dimensionWidth, dimensionProfile, dimensionRim };
};

export const getDimensionWidthFromTireDimension = (tireDimension: string) => {
  const match = tireDimension.match(/^(\d{3})\/\d{2}R\d{2}$/);
  return match ? match[1] : '';
};

export const getDimensionProfileFromTireDimension = (tireDimension: string) => {
  const match = tireDimension.match(/^\d{3}\/(\d{2})R\d{2}$/);
  return match ? match[1] : '';
};

export const getDimensionRimFromTireDimension = (tireDimension: string) => {
  const match = tireDimension.match(/^\d{3}\/\d{2}R(\d{2})$/);
  return match ? match[1] : '';
};
